<template>
    <div class="home-admin-content">
        <!-- Header da página -->
        <div class="dashboard-header-page">
            <div class="dashboard-title">
                <i class="fas fa-user-circle mr-2"></i>
                Meu Perfil
            </div>
            <div class="dashboard-subtitle mb-5">
                Gerencie suas informações pessoais e acompanhe suas reservas
            </div>
        </div>

        <!-- Seção das informações pessoais -->
        <div class="main-panel-section">
            <div class="card">
                <div class="panel-header">
                    <div class="panel-title">
                        <i class="fas fa-user mr-2"></i>
                        Informações Pessoais
                    </div>
                </div>

                <div class="card-body">
                    <div class="row">
                        <!-- Dados do usuário -->
                        <div class="col-md-10">
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label class="field-label">
                                            <i class="fas fa-user text-warning"></i>
                                            Nome
                                        </label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            :value="users.name || 'Não informado'"
                                            disabled
                                        />
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label class="field-label">
                                            <i class="fas fa-envelope text-warning"></i>
                                            E-mail
                                        </label>
                                        <input
                                            type="email"
                                            class="form-control"
                                            :value="users.email || 'Não informado'"
                                            disabled
                                        />
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label class="field-label">
                                            <i class="fas fa-mobile-alt text-warning"></i>
                                            Celular
                                        </label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            :value="users.cellphone || 'Não informado'"
                                            disabled
                                        />
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label class="field-label">
                                            <i class="fas fa-id-card text-warning"></i>
                                            Número da CNH
                                        </label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            :value="users.number_cnh || 'Não informado'"
                                            disabled
                                        />
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label class="field-label">
                                            <i class="fas fa-calendar-alt text-warning"></i>
                                            Validade da CNH
                                        </label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            :value="convertDateFromIso(users.validity_cnh)"
                                            disabled
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Foto do usuário -->
                        <div class="col-md-2">
                            <div class="user-photo-container">
                                <img
                                    :src="users.photo || '/default-user.png'"
                                    alt="Foto do usuário"
                                    class="user-photo"
                                    @error="handleImageError"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Seção das reservas -->
        <div class="row">
            <!-- Últimas reservas -->
            <div class="col-md-6">
                <div class="card main-panel-section">
                    <div class="panel-header">
                        <div class="panel-title">
                            <i class="fas fa-history mr-2"></i>
                            Minhas Últimas Reservas
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <div v-if="homeUser.last_trips && homeUser.last_trips.length > 0" class="trips-list">
                                <div
                                    v-for="(lastTrip, index) in homeUser.last_trips"
                                    :key="'last-' + lastTrip.id + '-' + index"
                                    class="trip-item"
                                >
                                    <div class="trip-indicator completed"></div>
                                    <div class="trip-content">
                                        <div class="trip-row">
                                            <span class="trip-label">
                                                <i class="fas fa-sign-out-alt text-success"></i>
                                                Retirado em:
                                            </span>
                                            <span class="trip-value">
                                                {{ lastTrip.checkout ? lastTrip.checkout.retreat_at : 'Não informado' }}
                                            </span>
                                        </div>
                                        <div class="trip-row">
                                            <span class="trip-label">
                                                <i class="fas fa-sign-in-alt text-info"></i>
                                                Entregue em:
                                            </span>
                                            <span class="trip-value">
                                                {{ lastTrip.checkin ? lastTrip.checkin.devoluted_at : 'Não informado' }}
                                            </span>
                                        </div>
                                    </div>
<!--                                    <div class="trip-action">-->
<!--                                        <button-->
<!--                                            type="button"-->
<!--                                            class="btn btn-sm btn-outline-warning"-->
<!--                                            @click="viewReserve(lastTrip.id)"-->
<!--                                            title="Visualizar detalhes"-->
<!--                                        >-->
<!--                                            <i class="fas fa-eye"></i>-->
<!--                                        </button>-->
<!--                                    </div>-->
                                </div>
                            </div>

                            <!-- Estado vazio para últimas reservas -->
                            <div v-else class="empty-state-small">
                                <i class="fas fa-history text-muted"></i>
                                <span>Você ainda não finalizou nenhuma reserva.</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Próximas reservas -->
            <div class="col-md-6">
                <div class="card main-panel-section">
                    <div class="panel-header">
                        <div class="panel-title">
                            <i class="fas fa-calendar-plus mr-2"></i>
                            Próximas Reservas
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <div v-if="homeUser.next_trips && homeUser.next_trips.length > 0" class="trips-list">
                                <div
                                    v-for="(nextTrip, index) in homeUser.next_trips"
                                    :key="'next-' + nextTrip.id + '-' + index"
                                    class="trip-item future"
                                >
                                    <div class="trip-indicator pending"></div>
                                    <div class="trip-content">
                                        <div class="trip-row">
                                            <span class="trip-label">
                                                <i class="fas fa-calendar-day text-warning"></i>
                                                Retirada:
                                            </span>
                                            <span class="trip-value">
                                                {{ nextTrip.retreat_date || 'Não informado' }}
                                            </span>
                                        </div>
                                        <div class="trip-row">
                                            <span class="trip-label">
                                                <i class="fas fa-calendar-check text-warning"></i>
                                                Devolução:
                                            </span>
                                            <span class="trip-value">
                                                {{ nextTrip.devolution_date || 'Não informado' }}
                                            </span>
                                        </div>
                                        <div class="trip-row">
                                            <span class="trip-label">
                                                <i class="fas fa-car text-warning"></i>
                                                Veículo:
                                            </span>
                                            <span class="trip-value">
                                                {{ nextTrip.vehicles ? nextTrip.vehicles.model : 'Não informado' }}
                                            </span>
                                        </div>
                                        <div class="trip-row">
                                            <span class="trip-label">
                                                <i class="fas fa-id-badge text-warning"></i>
                                                Placa:
                                            </span>
                                            <span class="trip-value">
                                                <span class="plate-badge">
                                                    {{ nextTrip.vehicles ? nextTrip.vehicles.board : 'N/A' }}
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Estado vazio para próximas reservas -->
                            <div v-else class="empty-state-small">
                                <i class="fas fa-calendar-plus text-muted"></i>
                                <span>Você não possui nenhuma reserva agendada.</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getMessage } from "../../composables/message";
import {convertDateFromIso} from "../../composables/functions";

export default {
    name: "HomeUser",

    data() {
        return {
            users: {},
            homeUser: {
                last_trips: [],
                next_trips: []
            }
        };
    },

    methods: {
        convertDateFromIso,
        /**
         * getHomeUser - busca dados específicos da home do usuário
         */
        getHomeUser() {
            const self = this;
            const api = self.$store.state.api + "homeUser/";

            self.$http
                .get(api)
                .then((response) => {
                    self.homeUser = response.data;
                })
                .catch((error) => {
                    const message = error.response.data.errors
                        ? getMessage(error.response.data.errors)
                        : error.response.data;
                    self.$message(null, message, "error");
                });
        },

        /**
         * viewReserve - visualiza detalhes de uma reserva específica
         * @param {number} reserveId - ID da reserva
         */
        viewReserve(reserveId) {
            console.log('Visualizar reserva:', reserveId);
        },

        /**
         * handleImageError - trata erro no carregamento da imagem do usuário
         */
        handleImageError() {
            this.users.photo = '/default-user.png';
        }
    },

    mounted() {
        const self = this;
        self.getHomeUser();
        this.users = this.$store.state.user;
    },
};
</script>

<style scoped>
.panel-title {
    padding: 15px;
    font-size: 16px;
}
/* Labels dos campos */
.field-label {
    display: flex;
    align-items: center;
    gap: 6px;
    font-weight: 600;
    color: #495057;
    font-size: 13px;
    margin-bottom: 5px;
}

/* Container da foto do usuário */
.user-photo-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    min-height: 200px;
}

.user-photo {
    width: 100%;
    max-width: 150px;
    height: auto;
    max-height: 200px;
    object-fit: cover;
    border-radius: 8px;
    border: 3px solid #f8981d;
    box-shadow: 0 4px 15px rgba(248, 152, 29, 0.2);
}

/* Display da categoria da CNH */
.category-display {
    font-weight: 600;
    text-align: center;
    background-color: transparent !important;
    border: 1px solid #FE8D18 !important;
}

.category-display.text-primary {
    color: #FE8D18 !important;
}

/* Lista de viagens */
.trips-list {
    max-height: 400px;
    overflow-y: auto;
    padding-right: 5px;
}

/* Item individual da viagem */
.trip-item {
    display: flex;
    align-items: flex-start;
    padding: 15px;
    margin-bottom: 12px;
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    transition: all 0.3s ease;
    position: relative;
}

.trip-item:hover {
    transform: translateX(3px);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
    border-color: #f8981d;
}

/* Indicador colorido da viagem */
.trip-indicator {
    width: 4px;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    border-radius: 0 0 0 8px;
}

.trip-indicator.completed {
    background: linear-gradient(180deg, #28a745, #20c997);
}

.trip-indicator.pending {
    background: linear-gradient(180deg, #FE8D18, #0056b3);
}

/* Conteúdo da viagem */
.trip-content {
    flex: 1;
    margin-left: 10px;
}

.trip-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
    font-size: 13px;
}

.trip-row:last-child {
    margin-bottom: 0;
}

.trip-label {
    display: flex;
    align-items: center;
    gap: 6px;
    font-weight: 500;
    color: #6c757d;
    min-width: 100px;
}

.trip-value {
    font-weight: 600;
    color: #2c3e50;
    text-align: right;
}

/* Badge da placa */
.plate-badge {
    background: linear-gradient(135deg, #f8981d, #fd7e14);
    color: white;
    padding: 2px 8px;
    border-radius: 4px;
    font-family: monospace;
    font-size: 11px;
    letter-spacing: 1px;
    font-weight: 700;
}

/* Ação da viagem */
.trip-action {
    margin-left: 10px;
    display: flex;
    align-items: center;
}

/* Estados vazios pequenos */
.empty-state-small {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 20px;
    text-align: center;
    color: #6c757d;
    font-size: 14px;
}

.empty-state-small i {
    font-size: 2rem;
    margin-bottom: 10px;
    opacity: 0.5;
}

/* Scrollbar personalizada */
.trips-list::-webkit-scrollbar {
    width: 6px;
}

.trips-list::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.05);
    border-radius: 3px;
}

.trips-list::-webkit-scrollbar-thumb {
    background: rgba(248, 152, 29, 0.3);
    border-radius: 3px;
}

.trips-list::-webkit-scrollbar-thumb:hover {
    background: rgba(248, 152, 29, 0.6);
}

/* Responsividade */
@media (max-width: 768px) {
    .user-photo-container {
        min-height: 150px;
        margin-top: 20px;
    }

    .user-photo {
        max-width: 120px;
        max-height: 150px;
    }

    .trip-item {
        flex-direction: column;
        gap: 10px;
    }

    .trip-action {
        margin-left: 0;
        align-self: flex-end;
    }

    .trip-row {
        flex-direction: column;
        align-items: flex-start;
        gap: 4px;
    }

    .trip-value {
        text-align: left;
    }

    .trip-label {
        min-width: auto;
    }
}

@media (max-width: 576px) {
    .field-label {
        font-size: 12px;
    }

    .trip-row {
        font-size: 12px;
    }

    .plate-badge {
        font-size: 10px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Report/HomeUser.vue